import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { AppLauncher } from '@capacitor/app-launcher';

import { IonicModule, ModalController } from '@ionic/angular';
import { TranslatePipe } from '@ngx-translate/core';
import { addIcons } from 'ionicons';
import { closeCircleOutline } from 'ionicons/icons';

@Component({
    selector: 'app-app-lock',
    templateUrl: './app-lock.modal.html',
    styleUrls: ['./app-lock.modal.scss'],
    imports: [
        CommonModule,
        IonicModule,
        TranslatePipe
    ]
})
export class AppLockComponent implements OnInit {
    public allowDismiss = true;

    @Input() version?: string;
    @Input() set force_update(value: boolean) {
        this.allowDismiss = !value;
    }
    @Input() message?: string;
    @Input() platform?: string;

    constructor(
        private _modalCtrl: ModalController,
    ) {
        addIcons({
            closeCircleOutline
        });

     }

    ngOnInit() {
    }

    goToUpdate() {
        this.dismissModal();
        // let appUrl = 'https://moviguide.com/audioguide';

        // if (this.platform === 'android') {
        //     appUrl = 'https://play.google.com/store/apps/details?id=com.moviguide';

        // } else if (this.platform === 'ios') {
        //     appUrl = 'https://apps.apple.com/pl/app/movi-guide/id1557887662?l=pl';
        // }

        // AppLauncher.openUrl({ url: appUrl});
    }


    dismissModal() {
        this._modalCtrl.dismiss({
            dismissed: true
        });
    }
}
